import React from "react";
import Sidebar from "./Sidebar";
import MainContent from "./MainContent";

const MainIndex = () => {
    return (
        <div className="App mesh-test">
            <div className="layout-wrapper">
                <Sidebar />
                <main className="dash-nav-body">
                    <MainContent />
                </main>
            </div>
            {/* <p className="dssdf">Copyright © 2024 All Rights Reserved BWE Financial Service LLP</p> */}
        </div>
    )
}


export default MainIndex